import { EmailServer } from 'types/domains'
import {
  DeploymentSetupOptions,
  InitialSetupFlowSettings,
  SetupFlowSteps
} from 'components/pages/setupFlow/types/egdWizardTypes'

export interface EmailServerConfig {
  server: string
  port: number | string
  domainId?: number
  domainName?: string
  verified?: boolean
  preference?: number
}

export type EmailServerResult = EmailServerConfig

export interface Provider {
  criteria: string
  providerName: string
  shortName: string
  url: string
}

export interface MxRecord {
  domain: string
  priority: number
  verified: boolean
}

export interface MxRecords {
  primary: MxRecord
  backup: MxRecord
}

export type OldMxRecords = MxRecord[]

export interface MicrosoftVerifiedDomain {
  name: string
  default: boolean
}

export interface UnavailableDomain {
  domain: string
  portal_id: string
  account_name: string
}

export interface DomainAvailability {
  available_domains: string[]
  unavailable_domains: UnavailableDomain[]
}

export interface EmailServerSettings {
  setupFlowStep: SetupFlowSteps | null
  region: string | null
  url: string | null
  email: string | null
  primaryMx: MxRecord | null
  backupMx: MxRecord | null
  emailServers: EmailServerConfig[] | null
  wizardCompleted: boolean
  provider: Provider[] | null
  oldMxRecords: MxRecord[] | null
  migrateToken: string
  version: 'v1' | 'v2' | null
  setupFlowSections: InitialSetupFlowSettings | null
  ipirAccountId: string | null
  ipirTokenId: string | null
  deploymentMethod: DeploymentSetupOptions | null
  inlineDeploymentStatus: INLINE_DEPLOYMENT_STATUSES | null
  inlineDeploymentJobName: string | null
  microsoftVerifiedDomains: MicrosoftVerifiedDomain[] | null
  microsoftConnected: boolean | null
  multiDomainSelectionEnabled?: boolean
  /** BNESS-32535: validated Microsoft domain selection awaiting commit (deferred domain commit) */
  pendingDomainNames?: string[] | null
}

export enum EmailServerType {
  A = 'a',
  MX = 'mx'
}

export interface AddMailServerRequest {
  domainId: string
  host: string
  preference: number
  type: EmailServerType
}

export type AddMailServerResponse = EmailServer

export interface RemoveMailServerRequest {
  domainId: string
  serverId: string
}

export type RemoveMailServerResponse = string

export interface UpdateMailServerRequest extends AddMailServerRequest {
  serverId: string
}

export type UpdateMailServerResponse = EmailServer

export interface TestMailServerRequest {
  domainId: string
  serverId: string
  recipient: string
  domainName: string
}

export type TestMailServerResponse = void

export interface StartInlineDeploymentResponse {
  jobName: string
}

export enum INLINE_DEPLOYMENT_STATUSES {
  PENDING = '`Pending`',
  RUNNING = 'Running',
  SUCCEEDED = 'Succeeded',
  FAILED = 'Failed'
}
export interface InlineDeploymentStatusResponse {
  status: INLINE_DEPLOYMENT_STATUSES
}
